export default __webpack_public_path__ + "static/media/couple@3x.3417d8ae.jpg";